/** Minutes of play at which the feedback panel opens by itself, in order. Only the device uses this
 * to decide when to ask; nothing about it is sent with the feedback. */
export const FEEDBACK_MILESTONES = [10, 60] as const;
export type FeedbackMilestone = (typeof FEEDBACK_MILESTONES)[number];

/** Longest comment the server accepts. */
export const FEEDBACK_COMMENT_MAX = 1000;

/** Shown when a feedback post fails for any reason except the daily limit. */
export const FEEDBACK_FAILED_MESSAGE = "Couldn't send your feedback. Please try again later.";

/** Shown when the server says this player has sent enough feedback for the day. */
export const FEEDBACK_LIMIT_MESSAGE =
  "Thank you for all the feedback but we need you to slow down. We'll reach out to have a one-on-one with you.";

/** What the player sent from the feedback panel: `POST /api/v1/feedback`. */
export interface FeedbackSubmission {
  /** 1 to 5 stars, or null when the player chose none. */
  rating: number | null;
  /** Trimmed text, or null when blank. */
  comment: string | null;
  platform: 'web';
  appVersion: string | null;
}

/**
 * The build version to send with feedback. CI builds the PWA with the 40 character git commit
 * hash, which the server's 32 character `appVersion` limit would not take; the first 8
 * characters still identify the commit. Any other version is sent unchanged. Telemetry keeps the
 * full hash.
 */
export function feedbackAppVersion(version: string): string {
  return /^[0-9a-f]{40}$/i.test(version) ? version.slice(0, 8) : version;
}
